/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_IntervalInputs */

const en_settings_billing_interval = /** @type {(inputs: Settings_Billing_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval`)
};

const zh_settings_billing_interval = /** @type {(inputs: Settings_Billing_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`周期`)
};

/**
* | output |
* | --- |
* | "Interval" |
*
* @param {Settings_Billing_IntervalInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_interval = /** @type {((inputs?: Settings_Billing_IntervalInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_IntervalInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_interval(inputs)
	return zh_settings_billing_interval(inputs)
});
export { settings_billing_interval as "settings.billing.interval" }